import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { ComponentProps } from "react";

import { useSearchBoxContext } from "@/components/Search/SearchBar/components/SearchBox/context/searchBox.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { preventUntrusted } from "@/utils/domElements";

type Props = ComponentProps<typeof Button>;

export const SubmitButton = ({ className, children, ...props }: Props) => {
    const { submitButtonRef } = useSearchBoxContext();
    const { t } = useGranite();

    return (
        <Button
            {...props}
            onClick={preventUntrusted()}
            fullWidth={true}
            type={"submit"}
            tabIndex={0}
            ref={submitButtonRef}
            aria-label={t("searchBox.input.button.submit")}
            className={cn(className)}
        >
            {children}
        </Button>
    );
};
